import React from 'react'

import ButtonIcon from './ButtonIcon'
import {ButtonView} from './styled'

const Button = ({id, onClick, className, title, ...iconProps}) => (
  <ButtonView id={id} onClick={onClick} className={className} title={title}>
    <ButtonIcon {...iconProps} />
  </ButtonView>
)

export default Button
